import React, {useState, useEffect} from "react"
import {Link, graphql, useStaticQuery} from "gatsby"

import "./style.scss"
import CookieImg from "../../assets/cookie.svg"
import {getCookie} from "../../utils/Utils"
import {gaInit} from "../../utils/GaUtils"

function triggerEvent(name, status) {
  document.dispatchEvent(new CustomEvent("consent", {detail: {name, status}}))
  document.dispatchEvent(new CustomEvent(`consent-${name}`, {detail: {status}}))
}

let cookies = getCookie("consent")
let initialState = {
  analytics: false,
}

if (cookies) {
  cookies = JSON.parse(atob(cookies))

  for (const elem in cookies) {
    triggerEvent(elem, cookies[elem])
    initialState[elem] = cookies[elem]
  }
}

const Consent = () => {
  const [visible, setVisible] = useState(false)
  const [analytics, setAnalytics] = useState(initialState.analytics)

  const {
    site: {
      siteMetadata: {gaId},
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          gaId
        }
      }
    }
  `)

  useEffect(() => {
    if (typeof gtag !== "undefined") {
      gaInit(gaId)
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (cookies === undefined) {
        setVisible(true)
      }
    }, 3000)
  }, [])

  useEffect(() => {
    const date = new Date()
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000)
    const cookieData = {}

    cookieData["analytics"] = analytics
    triggerEvent("analytics", analytics)

    const data = btoa(JSON.stringify(cookieData))
    document.cookie = `consent=${data};expires=${date.toUTCString()};path=/`
  }, [analytics])

  return (
    <div className="consent">
      <CookieImg className="trigger" onClick={() => setVisible(true)} />

      <div className={`content ${visible ? "visible" : ""}`}>
        <span className="description">
          This website uses cookies to enhance site navigation and analyze site
          usage. I don't need your private data, IP, nor anything else, I just
          want to know how many people use this website, so it makes sense to
          keep it alive. Without cookies, some features may not be available. By
          clicking "Accept cookies" you agree to our{" "}
          <Link to="/privacy-policy" className="consent-cookie-policy">
            Cookie Policy
          </Link>
          .
        </span>
        <form>
          <div className="option">
            <label>
              <input
                type="checkbox"
                name="necessary"
                checked={true}
                disabled="disabled"
              />
              <span>Necessary</span>
            </label>
          </div>
          <div className="option">
            <label>
              <input
                type="checkbox"
                name="analytics"
                checked={analytics}
                onChange={e => setAnalytics(e.target.checked)}
              />
              <span>Analytics</span>
            </label>
          </div>
          <div className="buttons">
            <button
              type="button"
              className="save"
              onClick={() => {
                setVisible(false)
              }}>
              Save
            </button>
            <button
              type="button"
              className="accept-all"
              onClick={() => {
                setAnalytics(true)
                setVisible(false)
              }}>
              Accept All
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Consent
